<span [innerHTML]="svgIcon()"></span>
